import { Broker } from './broker';

export let BROKER: Broker = <Broker> {
  id: '00000000-0000-0000-0000-000000000001',
  dotNumber: 'ABC12345'
};
